import React from "react";
import { FormattedMessage } from "react-intl";
import { Link, useSearchParams } from "react-router-dom";
import styles from "./ProductMenu.module.scss";

interface NavItem {
  translationId: string;
  defaultMessage: string;
  to: string;
  paramKey: string;
  paramValue: string;
}

const navItems: NavItem[] = [
  {
    translationId: "nav.woman",
    defaultMessage: "Woman",
    to: "/patterns?clients=female",
    paramKey: "clients",
    paramValue: "female",
  },
  {
    translationId: "nav.man",
    defaultMessage: "Man",
    to: "/patterns?clients=male",
    paramKey: "clients",
    paramValue: "male",
  },
  {
    translationId: "nav.girl",
    defaultMessage: "Girl",
    to: "/patterns?clients=girl",
    paramKey: "clients",
    paramValue: "girl",
  },
  {
    translationId: "nav.boy",
    defaultMessage: "Boy",
    to: "/patterns?clients=boy",
    paramKey: "clients",
    paramValue: "boy",
  },
  {
    translationId: "nav.newin",
    defaultMessage: "New In",
    to: "/patterns?sortBy=dateUpdated&sortOrder=desc",
    paramKey: "sortBy",
    paramValue: "dateUpdated",
  },
  {
    translationId: "nav.sale",
    defaultMessage: "Sale",
    to: "/patterns?hasDiscount=true",
    paramKey: "hasDiscount",
    paramValue: "true",
  },
  {
    translationId: "nav.newcollection",
    defaultMessage: "New Collection",
    to: "/patterns?sortBy=dateCreated&sortOrder=desc",
    paramKey: "sortBy",
    paramValue: "dateCreated",
  },
];

const ProductMenu: React.FC = () => {
  const [searchParams] = useSearchParams();

  const isActive = (item: NavItem): boolean => {
    return searchParams.get(item.paramKey) === item.paramValue;
  };

  return (
    <nav className={styles.productMenu}>
      <div className={styles.navItems}>
        {navItems.map((item) => (
          <Link
            key={item.translationId}
            to={item.to}
            className={`${styles.navLink} ${isActive(item) ? styles.active : ""}`}
          >
            <FormattedMessage
              id={item.translationId}
              defaultMessage={item.defaultMessage}
            />
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default ProductMenu;
